import * as Types from '../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type EventsQueryVariables = Types.Exact<{
  itineraryVersionId: Types.Scalars['ID'];
}>;


export type EventsQuery = { __typename?: 'Query', Events: Array<{ __typename?: 'ItineraryEvent', id: any, courierId: number, eventType?: Types.ItineraryEventType | null, identifier: any, identifierDescription?: string | null, actualTime: any, longitude?: number | null, latitude?: number | null, actualOrder?: number | null, itineraryOrder?: number | null, etaStartTime?: any | null, etaEndTime?: any | null, isEarlyDelivery?: boolean | null, isLocationApproximated: boolean, isManuallyGeocoded: boolean, address?: string | null, village?: string | null, town?: string | null, county?: string | null, pickedUpAwbNumbers?: string | null, visitTimeWindowStart?: any | null, visitTimeWindowEnd?: any | null, pickupPointClientName?: string | null }> };


export const EventsDocument = gql`
    query Events($itineraryVersionId: ID!) {
  Events(itineraryVersionId: $itineraryVersionId) {
    id
    courierId
    eventType
    identifier
    identifierDescription
    actualTime
    longitude
    latitude
    actualOrder
    itineraryOrder
    etaStartTime
    etaEndTime
    isEarlyDelivery
    isLocationApproximated
    isManuallyGeocoded
    address
    village
    town
    county
    pickedUpAwbNumbers
    visitTimeWindowStart
    visitTimeWindowEnd
    pickupPointClientName
  }
}
    `;

/**
 * __useEventsQuery__
 *
 * To run a query within a React component, call `useEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEventsQuery({
 *   variables: {
 *      itineraryVersionId: // value for 'itineraryVersionId'
 *   },
 * });
 */
export function useEventsQuery(baseOptions: Apollo.QueryHookOptions<EventsQuery, EventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
      }
export function useEventsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EventsQuery, EventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EventsQuery, EventsQueryVariables>(EventsDocument, options);
        }
export type EventsQueryHookResult = ReturnType<typeof useEventsQuery>;
export type EventsLazyQueryHookResult = ReturnType<typeof useEventsLazyQuery>;
export type EventsQueryResult = Apollo.QueryResult<EventsQuery, EventsQueryVariables>;